/**
 * Workspace 辅助工具
 * 统一处理 workspace 信息的获取
 */

/**
 * 获取当前用户的 workspace 信息
 * @returns {Object|null} - workspace 信息
 */
export const getCurrentWorkspace = () => {
  try {
    // 优先从初始化数据中获取 workspace 信息
    const initDataStr = localStorage.getItem('syntrust_init_data');
    if (initDataStr) {
      const initData = JSON.parse(initDataStr);
      if (initData.userDetail?.workspace) {
        return initData.userDetail.workspace;
      }
    }
    
    // 如果初始化数据中没有，尝试从用户数据中获取
    const userStr = localStorage.getItem('syntrust_user');
    if (userStr) {
      const userObj = JSON.parse(userStr);
      return userObj.workspace || null;
    }
  } catch (error) {
    console.error('获取 workspace 信息失败:', error);
  }
  return null;
};

/**
 * 获取 workspace ID
 * @returns {string} - workspace ID，默认为 'current'
 */
export const getWorkspaceId = () => {
  const workspace = getCurrentWorkspace();
  return workspace?.id || 'current';
};

/**
 * 获取 workspace 名称
 * @returns {string} - workspace 名称，默认为 'Alibaba'
 */
export const getWorkspaceName = () => {
  const workspace = getCurrentWorkspace();
  return workspace?.name || 'Alibaba';
};

/**
 * 获取用户团队列表
 * @returns {Array} - 用户团队列表
 */
export const getUserTeams = () => {
  try {
    const initDataStr = localStorage.getItem('syntrust_init_data');
    if (initDataStr) {
      const initData = JSON.parse(initDataStr);
      return initData.userTeams || [];
    }
  } catch (error) {
    console.error('获取用户团队列表失败:', error);
  }
  return [];
};

/**
 * 获取默认团队 ID（用于 workspace 导航）
 * @returns {string} - 默认团队 ID
 */
export const getDefaultTeamId = () => {
  const userTeams = getUserTeams();
  if (userTeams.length > 0) {
    return userTeams[0].id;
  }
};

/**
 * 检查用户是否有 workspace
 * @returns {boolean} - 是否有 workspace
 */
export const hasWorkspace = () => {
  const workspace = getCurrentWorkspace();
  return !!workspace;
};

/**
 * 检查用户是否有团队
 * @returns {boolean} - 是否有团队
 */
export const hasTeams = () => {
  const userTeams = getUserTeams();
  return userTeams.length > 0;
};

/**
 * 更新用户团队列表
 * @param {Array} newTeams - 新的团队列表
 */
export const updateUserTeams = (newTeams) => {
  try {
    const initDataStr = localStorage.getItem('syntrust_init_data');
    if (initDataStr) {
      const initData = JSON.parse(initDataStr);
      initData.userTeams = newTeams;
      localStorage.setItem('syntrust_init_data', JSON.stringify(initData));
    }
  } catch (error) {
    console.error('更新用户团队列表失败:', error);
  }
};

/**
 * 添加新团队到用户团队列表
 * @param {Object} newTeam - 新团队信息
 */
export const addUserTeam = (newTeam) => {
  try {
    const currentTeams = getUserTeams();
    const updatedTeams = [...currentTeams, newTeam];
    updateUserTeams(updatedTeams);
  } catch (error) {
    console.error('添加用户团队失败:', error);
  }
};

/**
 * 设置当前工作区
 * @param {Object} workspace - 工作区信息
 */
export const setCurrentWorkspace = (workspace) => {
  try {
    const initDataStr = localStorage.getItem('syntrust_init_data');
    if (initDataStr) {
      const initData = JSON.parse(initDataStr);
      initData.userDetail = {
        ...initData.userDetail,
        workspace
      };
      localStorage.setItem('syntrust_init_data', JSON.stringify(initData));
    }
  } catch (error) {
    console.error('设置当前工作区失败:', error);
  }
};

export default {
  getCurrentWorkspace,
  getWorkspaceId,
  getWorkspaceName,
  getUserTeams,
  getDefaultTeamId,
  hasWorkspace,
  hasTeams,
  updateUserTeams,
  addUserTeam,
  setCurrentWorkspace
}; 